import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

const MODULES = [CommonModule];
@Component({
  selector: 'app-dashboard-warnmap',
  standalone: true,
  imports: [...MODULES],
  templateUrl: './dashboard-warnmap.component.html',
  styleUrls: ['./dashboard-warnmap.component.scss'],
})
export class DashboardWarnmapComponent {
  source = input<string>();
  parameter = input<string>();
}
